/**
 * This reducer is used for validating products while adding to cart
 */
import {
    VALIDATE_PRODUCTS,
    VALIDATE_PRODUCTS_SUCCESS,
    VALIDATE_PRODUCTS_FAILURE,
    CLEAR_VALIDATED_PRODUCTS,
    CLEAR_TEMPLATE_PRODUCTS,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { CLEAR_ERROR } from '../actions/actionTypes';

const initialState = {
    validatedProducts: [],
    loading: false,
    loadingStatusArray: [],
    statusCode: 0,
    statusMessage: '',
    validProductsCount: 0,
    isEMEA: false,
    orderquantitythreshold: 0,
    salesOrg: '',
    accountError: '',
    surgeonError: '',
    templateProducts: [],
    isCondensedViewSearch: false,
};

const validateProductsReducer = (state = initialState, action) => {
    switch (action.type) {
        case VALIDATE_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loading: true,
                loadingStatusArray: Array.isArray(action?.payload?.products)
                    ? action.payload.products.map((product) => ({
                          cfn: product?.cfn || product?.productCFN,
                          salesOrg: product?.salesOrg,
                          loading: true,
                      }))
                    : [],
                statusCode: 0,
                validProductsCount: 0,
                isCondensedViewSearch:
                    action?.payload?.isCondensedViewSearch || false,
            };
        case VALIDATE_PRODUCTS_SUCCESS:
            return {
                ...state,
                validatedProducts: [...action?.validatedProducts],
                accountError: action?.accountError,
                surgeonError: action?.surgeonError,
                statusCode: action?.statusCode,
                statusMessage: action?.statusMessage,
                loading: false,
                validProductsCount: action?.validProductsCount,
                isEMEA: action?.isEMEA,
                orderquantitythreshold: action?.orderquantitythreshold,
                salesOrg: action?.salesOrg,
                templateProducts: action?.templateProducts,
                loadingStatusArray: initialState.loadingStatusArray,
            };
        case VALIDATE_PRODUCTS_FAILURE:
            return {
                ...state,
                validatedProducts: [],
                statusCode: action?.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
                validProductsCount: 0,
                isEMEA: false,
                orderquantitythreshold: 0,
                loadingStatusArray: initialState.loadingStatusArray,
                salesOrg: '',
            };
        case CLEAR_VALIDATED_PRODUCTS:
            return {
                ...state,
                validatedProducts: [],
                loading: false,
                validProductsCount: 0,
                statusCode: initialState?.statusCode,
                statusMessage: initialState.statusMessage,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
                loadingStatusArray: initialState.loadingStatusArray,
            };
        case CLEAR_TEMPLATE_PRODUCTS:
            return {
                ...state,
                templateProducts: initialState.templateProducts,
            };
        case CLEAR_ERROR:
            return {
                ...state,
                validatedProducts: [],
                loading: false,
                validProductsCount: 0,
                statusCode: initialState?.statusCode,
                statusMessage: initialState.statusMessage,
                accountError: initialState.accountError,
                surgeonError: initialState.surgeonError,
                loadingStatusArray: initialState.loadingStatusArray,
            };
        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'validateProductKey',
        storage: storage,
    },
    validateProductsReducer
);
